import {
    GET_REPORTS_START_DATE,
    SET_REPORTS_START_DATE,
    GET_REPORTS_END_DATE,
    SET_REPORTS_END_DATE
} from "../actions/date-time";
// utils
import {setHoursHelper} from "../../utils/common";

const state = {
    reports: {
        startDate: setHoursHelper(),
        endDate: setHoursHelper(24)
    }
};

const getters = {
    [GET_REPORTS_START_DATE]: state => state.reports.startDate,
    [GET_REPORTS_END_DATE]: state => state.reports.endDate
};

const actions = {
    [SET_REPORTS_START_DATE]: ({commit}, date) => commit(SET_REPORTS_START_DATE, date),
    [SET_REPORTS_END_DATE]: ({commit}, date) => commit(SET_REPORTS_END_DATE, date)
};

const mutations = {
    [SET_REPORTS_START_DATE]: (state, date) => {
        state.reports.startDate = date;
    },
    [SET_REPORTS_END_DATE]: (state, date) => {
        state.reports.endDate = date;
  }
};

export default {
    state,
    getters,
    actions,
    mutations
};